import React, { useRef, useEffect} from 'react';
import { StyledHugeText } from './StyledHugeText';
import { gsap } from "gsap";
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

const HugeText = ({ title, text, srcImg, align, bigTextClass }) => {

  const imgRef = useRef(null)
  const wrapRef = useRef(null)
  useEffect(() => {
    
    gsap.to(imgRef.current,{
      scrollTrigger:{
        scrub: 0.5,
        trigger: wrapRef.current,
        start: 'top center'
      },
      y: '-50%'
    })

  }, []);
  
  return (
    <React.Fragment>
      {
       
        <StyledHugeText>
          <div ref={wrapRef} className={`align--${align} huge-text--wrap`}>
            <h2 className={bigTextClass ? 'big--title' : 'md--title' }>{title}</h2>
            <p className="preset-10">{text}</p>
          </div>
          <div ref={imgRef} className={`align--${align} iframe--wrap`}>
            <img src={srcImg} />
          </div>
          
        </StyledHugeText>
          
          
      }
    </React.Fragment>
  );
};


export default HugeText;
